// --- Hooks ---
import { useLookupDeviceStatuses } from "../../utils/get-lookup";
// --- Components ---
import DashboardComponent from "../../components/dashboard";
import { useAtom } from 'jotai';
import { waterMonitoring } from '../../store/atoms/waterMonitoring.atom';

export default function Dashboard() {
    const { lookupDeviceStatuses } = useLookupDeviceStatuses();
    const [waterMonitoringData] = useAtom(waterMonitoring);
    if (!waterMonitoringData) return (
        <div className="flex items-center justify-center h-full">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
            <div className="ml-2">Waiting for data...</div>
        </div>
    );

    return (
        <div className="page-wrapper h-full">
            {waterMonitoringData && waterMonitoringData.length > 0 && waterMonitoringData.map((item: any, index: number) => (
                <div key={index} className="mb-6">
                    <DashboardComponent waterMonitoringData={item} deviceStatuses={lookupDeviceStatuses} />
                </div>
            ))}
        </div>
    );
}